<ic-ui-card
	loadingText="{{ 'general.fetching' | translate }} {{ 'general.titles.alarms' | translate | lowercase }}"
	[class.small-header]="!date()"
	[isLoading]="statisticsQuery?.isLoading()"
>
	<header>
		<pv-title>
			<ic-fa-icon icon="bell"> </ic-fa-icon>
			<h1>{{ 'general.titles.alarms' | translate }}</h1>
		</pv-title>

		@if (canViewDashboardAlarms) {
			<a class="ic-card-link right align-right" [class.top]="!date()" [routerLink]="['..', 'organisation', 'alarms']">
				{{ 'labels.alarms.goToList' | translate }} <i class="fa fa-chevron-right"></i>
			</a>
		}
	</header>

	<section>
		@if (!statisticsQuery?.isLoading() && canViewDashboardAlarms) {
			<ic-call-signal-statistics data-test="call-signal-overview-card" [statistics]="statisticsQuery.data()">
			</ic-call-signal-statistics>
		}
		@if (!canViewDashboardAlarms) {
			<p
				data-test="call-signal-overview-no-permission-message"
				class="ic-block small full-width text-center text-surface-500 py-8"
			>
				{{ 'general.no_permissions' | translate }}
			</p>
		}
	</section>
</ic-ui-card>
